import { useState } from "react";
import PropTypes from "prop-types";

import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";
import { resizeShopifyImage } from "@helpers/product";

import useDeviceDetect from "@hooks/useDeviceDetect";

import { ALSkeleton } from "@components/ALComponents";
import Gallery from "@components/Gallery";

import { ComponentType } from "@constants/ComponentType";

function ProductImage({ shopifyProduct, variant, componentType }) {
  const { isMobile } = useDeviceDetect();
  const [isImageLoaded, setIsImageLoaded] = useState(null);

  // For search
  const hasVariants = variant && typeof variant !== "string";

  const productImages = {
    main: hasVariants ? variant.image : shopifyProduct?.images?.[0],
    second: hasVariants ? shopifyProduct?.images?.[0] : shopifyProduct?.images?.[1],
  };

  const isByob =
    componentType === ComponentType.CP_BYOB || componentType === ComponentType.CP_BYOB_QUICKVIEW;
  let galleryImages;
  if (isByob) {
    galleryImages = shopifyProduct.images;
  } else if (shopifyProduct?.images?.length === 1) {
    galleryImages = [productImages.main];
  } else {
    galleryImages = [productImages.main, productImages.second];
  }

  // not using useResponsiveWithHydrationFix on purpose because
  // we don't want any first mobile render to cause mobile image loading on desktop
  const cpImages = isMobile ? (
    <Gallery
      images={galleryImages}
      componentType={componentType}
      className="mobile_image_slider"
      product={shopifyProduct}
    />
  ) : (
    <img
      onLoad={() => setIsImageLoaded(true)}
      className="w-full h-full object-cover absolute top-0"
      src={resizeShopifyImage(productImages.main.url, "600X600")}
      alt={productImages.main.altText}
    />
  );

  return (
    <>
      {shopifyProduct?.images?.length > 0 && (
        <>
          {!isImageLoaded && (
            <div className="relative mobile:absolute z-1 w-full h-full mobile:pb-[100%] pb-[125%]">
              <ALSkeleton className="absolute" position="absolute" />
            </div>
          )}

          {cpImages}
        </>
      )}

      {!isMobile && shopifyProduct?.images?.length > 1 && (
        <img
          className="absolute top-0 left-0 w-full h-full opacity-0 hidden desktop:flex desktop:group-hover/product-card:opacity-100 transition-opacity duration-10 ease-linear"
          src={resizeShopifyImage(productImages.second.url, "600X600")}
          alt={productImages.second.altText}
        />
      )}
    </>
  );
}

ProductImage.propTypes = {
  shopifyProduct: PropTypes.object,
  variant: PropTypes.object,
  componentType: PropTypes.string,
};

export default withALErrorBoundary({
  name: "ProductImage",
  priority: "P2",
})(ProductImage);
